import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function StoreSales() {
  const [salespeople, setSalespeople] = useState([])
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState('list')
  const [showAddModal, setShowAddModal] = useState(false)
  const [showConfigModal, setShowConfigModal] = useState(false)
  const [newPerson, setNewPerson] = useState({ name: '', phone: '', institution_id: '' })
  const [commissionConfig, setCommissionConfig] = useState({ direct_rate: 12, team_rate: 3, management_rate: 5, min_settle: 100 })

  useEffect(() => { loadSalespeople(); loadCommissionConfig() }, [])

  const loadSalespeople = () => {
    setLoading(true)
    fetch(`${API}/partners?type=institution_sales`).then(r => r.json())
      .then(d => { if (d.success) setSalespeople(d.data || []) })
      .catch(() => setSalespeople([
        { id: 'SP001', name: '张三', phone: '13800001111', institution_name: '演示机构', total_orders: 25, total_amount: 8950, commission: 1074 },
        { id: 'SP002', name: '李四', phone: '13800002222', institution_name: '演示机构', total_orders: 18, total_amount: 6200, commission: 744 },
        { id: 'SP003', name: '王五', phone: '13800003333', institution_name: '演示机构', total_orders: 32, total_amount: 12800, commission: 1536 },
      ]))
      .finally(() => setLoading(false))
  }

  const loadCommissionConfig = () => { fetch(`${API}/config/sales-commission`).then(r => r.json()).then(d => { if (d.success && d.data) setCommissionConfig(d.data) }) }

  const handleAddPerson = () => {
    if (!newPerson.name || !newPerson.phone) { alert('请填写姓名和手机号'); return }
    const id = 'SP' + Date.now().toString(36).toUpperCase()
    setSalespeople([...salespeople, { ...newPerson, id, total_orders: 0, total_amount: 0, commission: 0 }])
    setShowAddModal(false)
    setNewPerson({ name: '', phone: '', institution_id: '' })
  }

  const handleSaveConfig = () => {
    fetch(`${API}/config/sales-commission`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(commissionConfig) }).then(r => r.json())
      .then(d => { if (d.success) alert('配置已保存') })
      .catch(() => alert('配置已保存（演示模式）'))
    setShowConfigModal(false)
  }

  const fmt = (n) => n ? '¥' + Number(n).toLocaleString() : '¥0'

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🏪 门店业务员管理</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>管理业务员账户、提成配置和业绩统计</p>
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <button onClick={() => setShowAddModal(true)} style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>+ 添加业务员</button>
        <button onClick={() => setShowConfigModal(true)} style={{ padding: '10px 20px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>⚙️ 提成配置</button>
      </div>
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        {[{ k: 'list', l: '业务员列表' }, { k: 'performance', l: '业绩排行' }].map(t => (
          <button key={t.k} onClick={() => setTab(t.k)} style={{ padding: '8px 16px', border: 'none', borderRadius: 6, background: tab === t.k ? '#1890ff' : '#f5f5f5', color: tab === t.k ? '#fff' : '#666', cursor: 'pointer' }}>{t.l}</button>
        ))}
      </div>

      {tab === 'list' && (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#fafafa' }}>{['姓名', '手机号', '所属机构', '订单数', '成交金额', '累计佣金', '操作'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={7} style={{ ...td, textAlign: 'center', padding: 40 }}>加载中...</td></tr>
               : salespeople.length === 0 ? <tr><td colSpan={7} style={{ ...td, textAlign: 'center', padding: 40, color: '#999' }}>暂无业务员</td></tr>
               : salespeople.map(p => (
                  <tr key={p.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ ...td, fontWeight: 500 }}>{p.name}</td>
                    <td style={{ ...td, color: '#666' }}>{p.phone}</td>
                    <td style={{ ...td, color: '#666' }}>{p.institution_name || '-'}</td>
                    <td style={{ ...td, color: '#1890ff', fontWeight: 500 }}>{p.total_orders || 0}</td>
                    <td style={{ ...td, fontWeight: 500 }}>{fmt(p.total_amount)}</td>
                    <td style={{ ...td, color: '#52c41a', fontWeight: 600 }}>{fmt(p.commission)}</td>
                    <td style={td}><button style={{ padding: '4px 12px', background: '#f5f5f5', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>查看详情</button></td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'performance' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
          <h4 style={{ fontSize: 14, marginBottom: 16 }}>🏆 本月业绩排行</h4>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
            {salespeople.sort((a, b) => (b.total_amount || 0) - (a.total_amount || 0)).map((p, i) => (
              <div key={p.id} style={{ padding: 16, background: i === 0 ? '#fffbe6' : '#fafafa', borderRadius: 8, border: i === 0 ? '2px solid #faad14' : '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                  <div style={{ width: 32, height: 32, borderRadius: '50%', background: i === 0 ? '#faad14' : i === 1 ? '#d9d9d9' : i === 2 ? '#cd7f32' : '#999', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600 }}>{i + 1}</div>
                  <div><div style={{ fontWeight: 500 }}>{p.name}</div><div style={{ fontSize: 12, color: '#999' }}>{p.institution_name}</div></div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div><div style={{ fontSize: 12, color: '#999' }}>成交</div><div style={{ fontWeight: 600 }}>{fmt(p.total_amount)}</div></div>
                  <div style={{ textAlign: 'right' }}><div style={{ fontSize: 12, color: '#999' }}>佣金</div><div style={{ fontWeight: 600, color: '#52c41a' }}>{fmt(p.commission)}</div></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {showAddModal && (
        <div style={overlay}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 400 }}>
            <h3 style={{ fontSize: 16, marginBottom: 20 }}>添加业务员</h3>
            <div style={{ marginBottom: 16 }}><label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>姓名</label><input value={newPerson.name} onChange={e => setNewPerson({...newPerson, name: e.target.value})} style={inputStyle} placeholder="请输入姓名" /></div>
            <div style={{ marginBottom: 20 }}><label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>手机号</label><input value={newPerson.phone} onChange={e => setNewPerson({...newPerson, phone: e.target.value})} style={inputStyle} placeholder="请输入手机号" maxLength={11} /></div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowAddModal(false)} style={{ padding: '10px 20px', background: '#f5f5f5', border: 'none', borderRadius: 6, cursor: 'pointer' }}>取消</button>
              <button onClick={handleAddPerson} style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>添加</button>
            </div>
          </div>
        </div>
      )}

      {showConfigModal && (
        <div style={overlay}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 400 }}>
            <h3 style={{ fontSize: 16, marginBottom: 20 }}>⚙️ 业务员提成配置</h3>
            {[{ label: '直接提成 (%)', key: 'direct_rate', note: '首单佣金比例（默认12%）' }, { label: '团队提成 (%)', key: 'team_rate', note: '团队成员订单提成比例（默认3%）' }, { label: '管理奖 (%)', key: 'management_rate', note: '下属业务员额外奖励比例（默认5%）' }, { label: '最低结算金额(¥)', key: 'min_settle', note: '佣金满此金额才可提现（默认100元）' }].map(f => (
              <div key={f.key} style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>{f.label}</label>
                <input type="number" value={commissionConfig[f.key]} onChange={e => setCommissionConfig({...commissionConfig, [f.key]: Number(e.target.value)})} style={inputStyle} />
                <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{f.note}</div>
              </div>
            ))}
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowConfigModal(false)} style={{ padding: '10px 20px', background: '#f5f5f5', border: 'none', borderRadius: 6, cursor: 'pointer' }}>取消</button>
              <button onClick={handleSaveConfig} style={{ padding: '10px 20px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>保存配置</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const overlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }
